import { datadogRum } from '@datadog/browser-rum';

const datadogConfig = {
  applicationId: process.env.VUE_APP_DD_APPLICATION_ID,
  clientToken: process.env.VUE_APP_DD_CLIENT_TOKEN,
  site: process.env.VUE_APP_DD_SITE || 'us3.datadoghq.com',
  service: process.env.VUE_APP_DD_SERVICE || 'onlypay-console',
  env: process.env.VUE_APP_DD_ENV || process.env.NODE_ENV || 'development',
  version: process.env.VUE_APP_DD_VERSION,
};

let isRumInitialized = false;

function parseSampleRate(value, fallback) {
  if (value === undefined || value === '') return fallback;
  const n = Number(value);
  return Number.isFinite(n) ? n : fallback;
}

function isDatadogEnabled() {
  const value = process.env.VUE_APP_DD_ENABLED;
  if (value === undefined || value === '') return true;
  return !['false', '0', 'off', 'no'].includes(String(value).trim().toLowerCase());
}

function getAllowedTracingUrls() {
  const apiBaseUrl = process.env.VUE_APP_API_BASE_URL;
  if (!apiBaseUrl) return [];

  try {
    const { origin } = new URL(apiBaseUrl);
    return [origin];
  } catch {
    return [];
  }
}

export function initializeDatadogRum() {
  if (typeof window === 'undefined') return false;
  if (isRumInitialized) return true;
  if (!isDatadogEnabled()) return false;

  if (!datadogConfig.applicationId || !datadogConfig.clientToken) {
    return false;
  }

  const initOptions = {
    applicationId: datadogConfig.applicationId,
    clientToken: datadogConfig.clientToken,
    site: datadogConfig.site,
    service: datadogConfig.service,
    env: datadogConfig.env,
    sessionSampleRate: 100,
    sessionReplaySampleRate: parseSampleRate(
      process.env.VUE_APP_DD_SESSION_REPLAY_SAMPLE_RATE,
      20
    ),
    trackResources: true,
    trackUserInteractions: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
    allowedTracingUrls: getAllowedTracingUrls(),
  };

  if (datadogConfig.version) {
    initOptions.version = datadogConfig.version;
  }

  datadogRum.init(initOptions);
  isRumInitialized = true;
  return true;
}

export function trackDatadogView(route) {
  if (!isRumInitialized || !route) return;

  const routeName = route.name || route.meta?.title || route.path || 'unknown_route';
  const viewName = String(routeName);
  datadogRum.startView({ name: viewName });
}
